<mat-slider
    [id]="id"
    [formlyAttributes]="field"
    [tabIndex]="props.tabindex"
    [color]="props.color"
    (valueChange)="valueChangeHandler($event)"
    [thumbLabel]="props.thumbLabel"
    [step]="props.step"
    [max]="props.max"
    [min]="props.min"
    [value]="field.defaultValue"
    [displayWith]="formatLabel"
>
</mat-slider>